import { DialtoneLocalization as r } from "../../localization/index.js";
function a(e, t = null) {
  return new Intl.DateTimeFormat(t || r.getPreferredLocale(), { weekday: "long", year: "numeric", month: "long", day: "numeric" }).format(e);
}
function m(e, t = null) {
  return new Intl.DateTimeFormat(t || r.getPreferredLocale(), { year: "numeric", month: "long", day: "numeric" }).format(e);
}
function i(e, t = null, n = !0) {
  const o = n ? { weekday: "short", year: "numeric", month: "short", day: "numeric" } : { year: "numeric", month: "short", day: "numeric" };
  return new Intl.DateTimeFormat(t || r.getPreferredLocale(), o).format(e);
}
function l(e, t = null, n = !1) {
  const o = n ? "short" : "long";
  return new Intl.DateTimeFormat(t || r.getPreferredLocale(), { month: o, day: "numeric" }).format(e);
}
function u(e, t = null) {
  return new Intl.DateTimeFormat(t || r.getPreferredLocale(), { year: "2-digit", month: "2-digit", day: "2-digit" }).format(e);
}
const f = {
  formatLong: a,
  formatMedium: m,
  formatShort: i,
  formatNoYear: l,
  formatNumerical: u
};
export {
  f as default,
  a as formatLong,
  m as formatMedium,
  l as formatNoYear,
  u as formatNumerical,
  i as formatShort
};
//# sourceMappingURL=formatUtils.js.map
